import { render, staticRenderFns } from "./KardexProducto.vue?vue&type=template&id=2a78949d&"
import script from "./KardexProducto.vue?vue&type=script&lang=js&"
export * from "./KardexProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports